import http from '@/services/http'
import delayRequest from '@/utils/delay-request'
import * as types from './dashboard-startup.types'

export default {
  namespaced: true,
  state: {
    fetchInProgress: false,
    saveInProgress: false,
    startup: {
      id: '',
      name: '',
      slug: '',
      caption: '',
      bg_img_url: '',
      logo_url: '',
      amount_raising: '',
      previous_rounds: '',
      sector: 'choose',
      city: '',
      country: 'PL',
      website: undefined,
    },
  },

  mutations: {
    [types.START_FETCH](state) {
      state.fetchInProgress = true
    },
    [types.STOP_FETCH](state) {
      state.fetchInProgress = false
    },
    [types.START_SAVE](state) {
      state.saveInProgress = true
    },
    [types.STOP_SAVE](state) {
      state.saveInProgress = false
    },
    [types.SET_STARTUP_DATA](state, data) {
      Object.assign(state.startup, data)
    },
    [types.API_ERROR](state, errors) {
      state.errors = errors
    },
    [types.SET_BG_IMG_URL](state, url) {
      state.startup.bg_img_url = url
    },
    [types.SET_LOGO_URL](state, url) {
      state.startup.logo_url = url
    },
    [types.REMOVE_BG_IMG_URL](state) {
      state.startup.bg_img_url = null
    },
    [types.REMOVE_LOGO_URL](state) {
      state.startup.logo_url = null
    },
  },

  actions: {
    fetch({ commit }) {
      commit(types.START_FETCH)

      const request = http.getAuthed('/startups/basic-details')
      delayRequest(request)
        .then((response) => {
          commit(types.SET_STARTUP_DATA, response.data)
        })
        .finally(() => {
          commit(types.STOP_FETCH)
        })
    },
    save({ commit, state }) {
      commit(types.START_SAVE)
      const startupId = state.startup.id
      const request = http.postAuthed(
        `/startups/${startupId}/update`,
        state.startup,
      )
      delayRequest(request)
        .catch((response) => {
          commit(types.API_ERROR, response.data)
        })
        .finally((response) => {
          commit(types.STOP_SAVE)
        })
    },
  },
}
